import {Component} from "react";
import {useLocation} from "react-router-dom";

import DeployBoundary from "../AccessBoundary/DeployBoundary";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {hasError: false};
  }

  static getDerivedStateFromError(error) {
    // Показать fallback UI
    return {hasError: true, error: error.message};
  }

  componentDidCatch(error, info) {
    console.error("Помилка у компоненті:", error);
    console.error("Stack trace:", info.componentStack);
    // Если нужно логировать:
    // logErrorToMyService?.(error, info.componentStack);
  }

  componentDidUpdate(prevProps) {
    // Сброс ошибки при смене маршрута
    if (this.props.location !== prevProps.location && this.state.hasError) {
      this.setState({hasError: false});
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? (
          <DeployBoundary />
          // <div
          //   style={{
          //     position: "relative",
          //     height: "90vh",
          //     width: "100vw",
          //     display: "flex",
          //     justifyContent: "center",
          //     alignItems: "center",
          //   }}
          // >
          //   <label style={{position: "absolute", margin: "0 auto"}}>{this.state.error} Цей розділ ще в розробці</label>
          // </div>
        )
      );
    }

    return this.props.children;
  }
}

// HOC для прокидывания location (аналог withRouter в React Router v6)
function ErrorBoundaryWithLocation(props) {
  const location = useLocation();
  return <ErrorBoundary {...props} location={location} />;
}

export default ErrorBoundaryWithLocation;
